// Different kinds will be available in the future.
type Kind = 'text';

export interface ChatUser {
  uid: string;
  firstname: string;
  lastname: string;
  isSender: boolean;
}

export interface AnyMessageGeneric<
  T extends Kind,
  U extends ChatUser,
  C extends Record<string, unknown>
> {
  kind: T;
  user: U;
  content: C;
  date: Date;
  error?: string;
}

export type AnyMessage = AnyMessageGeneric<
  Kind,
  ChatUser,
  Record<string, unknown>
>;

export type TextMessage = AnyMessageGeneric<
  'text',
  ChatUser,
  {
    text: string;
  }
>;

export function isTextMessage(message: AnyMessage): message is TextMessage {
  return message.kind === 'text';
}
